<template>
  <div>
    <!-- Conditional rendering for components -->
    <div v-if="view === 'signup'">
      <SignUpComponent @switch-view="switchView" @signup-success="redirectToCustomize" />
    </div>
    <div v-if="view === 'login'">
      <LogInComponent @switch-view="switchView" @login-success="redirectToCustomize" />
    </div>
  </div>
</template>

<script>
import SignUpComponent from './components/signupComponent.vue';
import LogInComponent from './components/loginComponent.vue';

export default {
  components: {
    SignUpComponent,
    LogInComponent,
  },
  data() {
    return {
      view: 'signup',
    };
  },
  methods: {
    switchView(newView) {
      this.view = newView; // Switch view when child component emits the event
    },
    redirectToCustomize() {
      this.$router.push('/configure/user/customize'); // Redirect to Customize page
    },
  },
  created() {
    // Check query parameter to set the initial view
    const queryView = this.$route.query.view;
    if (queryView === 'login' || queryView === 'signup') {
      this.view = queryView;
    }
  },
};
</script>
